import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const HeritageTours = () => {
  return <ThemeToursTemplate theme="heritage" />;
};

export default HeritageTours;
